"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scene_card_1 = require("ayvri-ui/lib/scene-card");
var React = require("react");
var activities_1 = require("../../helpers/activities");
var env_1 = require("../../helpers/env");
var styles_1 = require("./styles");
exports.SceneCard = function (props) {
    var scene = props.scene, tags = props.tags, thumbnail = props.thumbnail;
    var sceneUrl = "/scene/" + scene.accountId + "/" + (scene.sceneId || '');
    var activityImage = activities_1.mapActivitiesToImage(scene.activityType || '');
    var activityImageUrl = env_1.env().staticSrcPath() + "/assets/images/activities/" + activityImage + "40PX.svg";
    return (React.createElement("div", { className: styles_1.styles.cardContainer },
        React.createElement(scene_card_1.SceneCard, { title: scene.title || 'Untitled Scene', location: scene.locationName, creator: scene.accountName, sceneUrl: sceneUrl, tags: tags, thumbnail: thumbnail, assetsBaseUrl: env_1.env().staticSrcPath() + "/assets", trackCount: scene.numberOfActivities, photoCount: 0, commentCount: 0, renderActivityIcon: function () { return React.createElement("img", { src: activityImageUrl, style: { borderRadius: '50%' } }); } })));
};
exports.SceneCard.displayName = 'WebsiteSceneCard';
